import { render } from "./PostalLabel.vue?vue&type=template&id=a1a8d8b8&scoped=true"
import script from "./PostalLabel.vue?vue&type=script&lang=js"
export * from "./PostalLabel.vue?vue&type=script&lang=js"

import "./PostalLabel.vue?vue&type=style&index=0&id=a1a8d8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a8d8b8"]])

export default __exports__